import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
    container: {
        position: 'fixed',
        top: -1000,
        left: -1000,
        width: 10000,
        height: 10000,
        backgroundColor: 'transparent',
        zIndex: 3000
    }
}))

function BlockPage({ open }) {
    const classes = useStyles();

    if (!open) return null;
    return (
        <div id="block-page" className={classes.container} />
    );
}

BlockPage.propTypes = {
    open: PropTypes.bool.isRequired
};

export default BlockPage;
